class Validate {
  /**
   * retorna a message da primeira validação que falhar
   * @param {string} value string a ser validada
   * @param {{
   *   notAStringReason: string,
   *   minLength:    { expected: number, reason: string },
   *   equalsLength: { expected: number, reason: string },
   *   maxLength:    { expected: number, reason: string },
   * }} options validações
   */
  static validateString(value, options = {}) {
    if (!options) options = {};

    if (typeof value !== "string" || value === undefined || value === null)
      return options.notAStringReason || 'String inválida';

    /** length */
    if (options.equalsLength && value.length !== options.equalsLength.expected)
      return options.equalsLength.reason;

    if (options.minLength && value.length < options.minLength.expected)
      return options.minLength.reason;

    if (options.maxLength && value.length > options.maxLength.expected)
      return options.maxLength.reason;

    return null;
  }
}

module.exports = Validate;